function useFromSelfCheckin(props) {
  let fromSelfCheckin = {
    isFromSelfCheckin: false,
    selfCheckinToken: ''
  };

  if (props?.state?.from?.state?.isFromSelfCheckin) {
    fromSelfCheckin.isFromSelfCheckin = true;
    fromSelfCheckin.selfCheckinToken = props.state.from.state.selfCheckinToken;
  } else if (props?.state?.isFromSelfCheckin) {
    fromSelfCheckin.isFromSelfCheckin = true;
    fromSelfCheckin.selfCheckinToken = props.state.selfCheckinToken;
  }
  return fromSelfCheckin;
}

export default useFromSelfCheckin